var map = {
	"./cn.json": "f4a5",
	"./de.json": "6ce2",
	"./en.json": "edd4",
	"./es.json": "a306",
	"./fr.json": "f693",
	"./id.json": "210c",
	"./it.json": "0825",
	"./jp.json": "9e97",
	"./kr.json": "c1af",
	"./pt.json": "5d67",
	"./ru.json": "7704",
	"./thai.json": "955a",
	"./tr.json": "ffeb",
	"./vt.json": "7070"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "49f8";